import { hostHas, type HostFeature } from '../shared/host-capabilities';

/**
 * The desktop's window events that open a Settings screen, and the host feature each screen is. Paige hides
 * those features (paige-host.ts), and Settings drops a hidden section only after it has rendered once, so the
 * event itself is stopped here: no Paige customer sees License's "Cloud credits" card (Paige counts pages,
 * ADR-0030) or Performance, which measures the operator's own computer. The synced renderer is not edited.
 */
const settingsEvents: Readonly<Record<string, HostFeature>> = {
  'capturepoint-open-license': 'licensing',
  'capturepoint-open-performance': 'local-performance',
};

/** Stops each event whose screen this host hides, before the workbench's own listener; returns the teardown. */
export function blockHiddenHostEvents(): () => void {
  const block = (event: Event) => {
    if (!hostHas(settingsEvents[event.type]!)) event.stopImmediatePropagation();
  };
  // At the target, a capturing listener runs before every non-capturing one, whenever it was added.
  const names = Object.keys(settingsEvents);
  for (const name of names) window.addEventListener(name, block, { capture: true });
  return () => {
    for (const name of names) window.removeEventListener(name, block, { capture: true });
  };
}
